import React, { useState} from 'react';
import Select from 'react-select'
import { t } from '../i18n';

const Language = () => {
  const [error] = useState('');
  var language = localStorage.getItem("language");
  var setLanguage = function(newLanguage){
    localStorage.setItem("language", newLanguage);
    language = newLanguage;
  }

  const options = [
    { value: 'ar', label: 'العربية' },            // Arabic
    { value: 'bg', label: 'Български' },          // Bulgarian
    { value: 'ca', label: 'Català' },             // Catalan
    { value: 'cs', label: 'Čeština' },            // Czech
    { value: 'de', label: 'Deutsch' },            // German
    { value: 'el', label: 'Ελληνικά' },           // Greek
    { value: 'en', label: 'English' },            // English
    { value: 'es', label: 'Español' },            // Spanish
    { value: 'fa', label: 'فارسی' },              // Persian
    { value: 'fi', label: 'Suomi' },              // Finnish
    { value: 'fr', label: 'Français' },           // French
    { value: 'he', label: 'עברית' },              // Hebrew
    { value: 'hr', label: 'Hrvatski' },           // Croatian
    { value: 'it', label: 'Italiano' },           // Italian
    { value: 'ja', label: '日本語' },               // Japanese
    { value: 'ko', label: '한국어' },              // Korean
    { value: 'lt', label: 'Lietuvių' },           // Lithuanian
    { value: 'no', label: 'Norsk' },              // Norwegian
    { value: 'pl', label: 'Polski' },             // Polish
    { value: 'pt-BR', label: 'Português (Brasil)' },
    { value: 'ro', label: 'Română' },             // Romanian
    { value: 'ru', label: 'Русский' },            // Russian
    { value: 'sk', label: 'Slovenčina' },         // Slovak
    { value: 'sl', label: 'Slovenščina' },        // Slovenian
    { value: 'sr', label: 'Српски' },             // Serbian
    { value: 'sv', label: 'Svenska' },            // Swedish
    { value: 'tr', label: 'Türkçe' },             // Turkish
    { value: 'uz', label: 'Oʻzbekcha' },          // Uzbek
    { value: 'vi', label: 'Tiếng Việt' },         // Vietnamese
    { value: 'zh-Hans', label: '简体中文' },        // Chinese Simplified
    { value: 'zh-Hant', label: '繁體中文' }         // Chinese Traditional
  ];

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '400px', margin: '50px auto' }}>
        <h2>{t('chooseLanguage')}</h2>
        {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
        <Select
          value={options.find(option => option.value === language)}
          onChange={(option) => {
            setLanguage(option.value);
            window.location.reload();
          }}
          options={options}
        />
        
      </div>
    </div>
  );
};

export default Language;
